var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldCalenderFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.5v9.25A3.25 3.25 0 0114.75 18H3.25A3.25 3.25 0 010 14.75V5.5h18zM4.25 12a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM9 12a1.25 1.25 0 100 2.5A1.25 1.25 0 009 12zM4.25 7.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM9 7.5A1.25 1.25 0 109 10a1.25 1.25 0 000-2.5zm4.75 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm1-7.5A3.25 3.25 0 0118 3.25V4H0v-.75A3.25 3.25 0 013.25 0h11.5z",
    fill: "#000"
  })));
}
export default SvgPldCalenderFilled;